export default {"src":"/_next/static/media/deco_checkout_camera.fb0f77f0.svg","height":16,"width":20,"blurWidth":0,"blurHeight":0};